import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import axios from "axios";
import { axiosErrorHandler } from "../../../swzutils";
const TenantPartnerVehiclesSelect = ({ tenantId, partnerTenantId, disabled = false, allowClear = false, placeholder = "Select a partner", value, style, onChange, onVehicleSelected }) => {
    const [vehicles, setVehicles] = useState([]);
    const [vehicleOptions, setVehicleOptions] = useState([]);
    useEffect(() => {
        if (tenantId && partnerTenantId) {
            loadContractorVehicles();
        }
    }, [tenantId, partnerTenantId]);
    const loadContractorVehicles = () => {
        axios.get(`/admin/v1/tenants/${tenantId}/partnerships/${partnerTenantId}/vehicles`).then(response => {
            const vehicles = response.data;
            const vehicleOptions = vehicles.map((vehicle) => {
                const description = vehicle.registration + " - " + vehicle.type.description;
                return {
                    label: description,
                    value: vehicle.id
                };
            });
            setVehicles(vehicles);
            setVehicleOptions(vehicleOptions);
            // If the selected vehicle id is no longer in the list then clear it
            const selectedId = Number(value);
            if (vehicles.filter(vehicle => vehicle.id === selectedId).length <= 0) {
                onChange && onChange(null);
            }
        }).catch(axiosErrorHandler);
    };
    const onSelectChanged = (val) => {
        onChange && onChange(val);
        if (val && onVehicleSelected) {
            const vehicle = vehicles.find(t => t.id === val);
            if (vehicle) {
                onVehicleSelected(vehicle);
            }
        }
    };
    return (_jsx(Select, { disabled: disabled, allowClear: allowClear, placeholder: placeholder, style: style, onChange: onSelectChanged, value: value, showSearch: {
            optionFilterProp: ['label']
        }, options: vehicleOptions }));
};
export default TenantPartnerVehiclesSelect;
